module.exports = __webpack_public_path__ + "static/media/p208b2.bfcf80d8.jpg";